/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import dashboardAPI from '@/api/dashboardAPI.js';
import httpClient from '../../api/axios-httpclient';

export default {
	loadFilingstatus: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: dashboardAPI.getAPIUrl() + '/filingstatus',
				data: payload
			},
			true
		);

		return res;
	},
	loadPaidStatus: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: dashboardAPI.getAPIUrl() + '/paidstatus',
				data: payload
			},
			true
		);

		return res;
	},
	loadTaxPaid: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: dashboardAPI.getAPIUrl() + '/taxpaid',
				data: payload
			},
			true
		);

		return res;
	},
	loadTaxMustFiled: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: dashboardAPI.getAPIUrl() + '/taxmustfiled',
				data: payload
			},
			true
		);

		return res;
	},

	checkTypeMoneyUse: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: dashboardAPI.getAPIUrl() + '/typemoneyuse',
				params: payload
			},
			true
		);

		return res;
	}
};
